<template>
     <!-- 备案信息 -->
    <div class="copyright">
      <p>Copyright © 2020 SpaceCode All Rights Reserved. 京ICP备13019895号-1</p>
      <p>工信部网站 <a href="http://www.beian.miit.gov.cn" target="_blank">http://www.beian.miit.gov.cn</a> </p>
    </div>
</template>

<script>
  export default {
    name: 'copyRight'
  }
</script>

<style lang="scss">
.copyright{
  position: absolute;
  height: 60px;
  font-size: 12px;
  color: #ccc;
  width: 100%;
  z-index: 100000;
  bottom: 0px;
  p{
    text-align: center;
    line-height: 20px;
    a{
      color: #ccc;
      text-decoration: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cr.vue